import { LoadableLazy } from '@confluence/loadable';

export const LazySmartFolderQuickActionMenuItem = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SmartFolderQuickActionMenuItem" */ '../src/SmartFolderQuickActionMenuItem.tsx'
			)
		).SmartFolderQuickActionMenuItem,
});

LazySmartFolderQuickActionMenuItem.displayName = 'lazy(SmartFolderQuickActionMenuItem)';
